// extracted by mini-css-extract-plugin
export var hidden = "_sq-0";